import { TitulationLoader } from './parts/TitulationLoader';
import { Alert } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionTitle } from '../../../../../../components/text';
import Table from './parts/Table';
import { StudentSummary } from './parts/StudentSummary';

type Props = {
  studyPlanEnrollmentId: string;
};

export function Titulation({ studyPlanEnrollmentId }: Props) {
  const dictPrefix = 'studentsDegreeStudent';
  const { t } = useTranslation();
  const texts = useMemo(
    () => ({
      title: t(`${dictPrefix}.title`),
      subtitle: t(`${dictPrefix}.subtitle`),
      subtitleWitoutActivities: t(`${dictPrefix}.subtitleWitoutActivities`),
      box: t<
        string,
        Record<
          'student' | 'studyPlan' | 'schedule' | 'semester' | 'campus',
          string
        >
      >(`${dictPrefix}.box`, {
        returnObjects: true,
      }),
      noActivities: t(`${dictPrefix}.noActivities`),
    }),
    [t],
  );
  return (
    <TitulationLoader studyPlanEnrollmentId={studyPlanEnrollmentId}>
      {({ data }) => (
        <section className="petition-summary mb-4">
          <div className="mb-3">
            <SectionTitle text={texts.title} />
          </div>
          <div className="mb-3">
            {Boolean(data.degreeProcess.activities.length) ? (
              <p>{texts.subtitle}</p>
            ) : (
              <p>{texts.subtitleWitoutActivities}</p>
            )}
          </div>
          {Boolean(data.degreeProcess.activities.length) && (
            <div className="mb-4">
              <Table data={data.degreeProcess.activities} />
            </div>
          )}
          {!data.degreeProcess.activities.length && (
            <div className="mb-4">
              <Alert
                className=""
                color="info"
                icon="information"
                size="lg"
                text={texts.noActivities}
              />
            </div>
          )}
          <StudentSummary
            planStatus={data.studyPlanEnrollment.status}
            graduationGrade={
              data.degreeProcess.summary?.gradeGraduation ||
              data.graduation.grade
            }
            distinctionRank={
              data.degreeProcess.summary?.distinctionRank?.name || ''
            }
            financialBlockade={data.financialBlockade}
            date={data.degreeProcess.summary?.date}
            degreeGrade={
              data.degreeProcess.summary?.gradeDegreeProcess || undefined
            }
          />
        </section>
      )}
    </TitulationLoader>
  );
}
